module.exports = __webpack_public_path__ + "static/triangle-bg-24cf9d11a83f643d843f61aa3ebbbbb0.png";